<template>
	<v-bottom-sheet :value="show"
		:overlay-opacity="1"
		@input="handleCloseClick"
	>
		<v-sheet class="text-center text--primary px-12 py-12" >
			<h2 class="text-h2 mb-6">
				<template v-if="!title">Something went wrong</template>
				<template v-else>{{title}}</template>
			</h2>
			<p v-if="message" 
				v-html="message"
				class="text-body-1"
			></p>
			<p v-if="!buttons.length" 
				class="text-body-1 mt-12"
			>
				<v-btn rounded
					depressed
					color="secondary"
					@click.prevent="handleCloseClick()"
				>Close</v-btn>
			</p>
		</v-sheet>
	</v-bottom-sheet>
</template>
<script>
import Vue from 'vue';
import { mapState } from 'vuex';
// import { util } from '@/mixins/util.js';
import Analytics from '../mixins/analytics';

export default Vue.extend({
	name: 'ErrorModal', 
	props: {
		show: Boolean
	},
	computed: {
		...mapState({
			buttons(){
				return this.$store.state.openModal.buttons || [];
			},
			message(){
				return this.$store.state.openModal.message || '';
			},
			title(){
				return this.$store.state.openModal.title || '';
			}
		})
	}, 
	methods: {
		handleCloseClick(){
			this.$store.commit('resetOpenModal');
		}
	}, 
	watch: {
		'message'(){
			this.message && Analytics.sendError(this.message);
		}
	},
	mounted(){
        // this.$store.commit('setLoading', { show: false });
	}
})
</script>
